var map = {
	"./Tamilnadu-Assembly-NEW.svg": 178,
	"./action.svg": 207,
	"./adventure.svg": 208,
	"./advertorial.svg": 209,
	"./ai.svg": 210,
	"./album.svg": 211,
	"./analysis.svg": 212,
	"./anchor.svg": 213,
	"./android-block.svg": 214,
	"./android-small.svg": 215,
	"./android.svg": 216,
	"./angle-down.svg": 217,
	"./angle-left.svg": 218,
	"./angle-right.svg": 219,
	"./angle-up.svg": 220,
	"./aquarius.svg": 221,
	"./arcade.svg": 222,
	"./aries.svg": 223,
	"./arrow-down.svg": 224,
	"./arrow-left.svg": 225,
	"./arrow-right.svg": 226,
	"./arrow-up.svg": 227,
	"./arrow.svg": 228,
	"./art-director.svg": 229,
	"./astrology.svg": 230,
	"./author-avator.svg": 231,
	"./author.svg": 232,
	"./authoranchor.svg": 233,
	"./authorwhite.svg": 234,
	"./automobile.svg": 235,
	"./backward.svg": 236,
	"./bookmark.svg": 237,
	"./books-vikatan.svg": 238,
	"./brandconnect.svg": 239,
	"./breaking-news.svg": 240,
	"./bullet-arrow.svg": 241,
	"./bundle.svg": 242,
	"./business.svg": 243,
	"./calendar.svg": 244,
	"./cancel.svg": 245,
	"./cancer.svg": 246,
	"./canvas.svg": 247,
	"./capricorn.svg": 248,
	"./cartoonist.svg": 249,
	"./cinema.svg": 250,
	"./clapboard.svg": 251,
	"./clipboard.svg": 252,
	"./close.svg": 253,
	"./comment.svg": 254,
	"./corona-updates-icon.svg": 255,
	"./creative-director.svg": 256,
	"./cricket.svg": 257,
	"./crime.svg": 258,
	"./data.svg": 259,
	"./designed.svg": 260,
	"./double-arrow.svg": 261,
	"./downarrow.svg": 262,
	"./download.svg": 263,
	"./edit.svg": 264,
	"./edited-by.svg": 265,
	"./election-2026.svg": 266,
	"./email.svg": 267,
	"./environment.svg": 268,
	"./exclusivedeals.svg": 269,
	"./facebook-bg.svg": 270,
	"./facebook-icon.svg": 271,
	"./facebook.svg": 272,
	"./filter-icon.svg": 273,
	"./filter.svg": 274,
	"./food-stylist.svg": 275,
	"./forward.svg": 276,
	"./gallery.svg": 277,
	"./game-shop.svg": 278,
	"./gemini.svg": 279,
	"./group.svg": 280,
	"./gzhome.svg": 281,
	"./gzsports.svg": 282,
	"./gztrending.svg": 283,
	"./health.svg": 284,
	"./hexbackground.svg": 285,
	"./home.svg": 286,
	"./humoursatire-entertainment.svg": 287,
	"./icon-apple.svg": 288,
	"./icon-appstore.svg": 289,
	"./icon-audio-app-store.svg": 290,
	"./icon-audio-fb.svg": 291,
	"./icon-audio-instagram.svg": 292,
	"./icon-audio-next.svg": 293,
	"./icon-audio-play-store.svg": 294,
	"./icon-audio-previous.svg": 295,
	"./icon-audio-twitter.svg": 296,
	"./icon-audio-whatsapp.svg": 297,
	"./icon-comments-share.svg": 298,
	"./icon-copy.svg": 299,
	"./icon-election.svg": 300,
	"./icon-episode.svg": 301,
	"./icon-facebook.svg": 302,
	"./icon-filter.svg": 303,
	"./icon-google-play.svg": 304,
	"./icon-headset.svg": 305,
	"./icon-home-plus.svg": 306,
	"./icon-login.svg": 307,
	"./icon-open-in-new.svg": 308,
	"./icon-pause.svg": 309,
	"./icon-play.svg": 310,
	"./icon-playstore.svg": 311,
	"./icon-premium.svg": 312,
	"./icon-share.svg": 313,
	"./icon-star.svg": 314,
	"./icon-timer.svg": 315,
	"./icon-twitter.svg": 316,
	"./icon-user.svg": 317,
	"./icon-video.svg": 318,
	"./icon-whatsapp.svg": 319,
	"./illustrator-t1.svg": 320,
	"./illustrator.svg": 321,
	"./infographer.svg": 322,
	"./instagram.svg": 323,
	"./interviews.svg": 324,
	"./ios-block.svg": 325,
	"./ios-small.svg": 326,
	"./ios.svg": 327,
	"./jokes.svg": 328,
	"./leo.svg": 329,
	"./libra.svg": 330,
	"./lifestyle.svg": 331,
	"./like.svg": 332,
	"./line-arrow-next.svg": 333,
	"./line-arrow-prev.svg": 334,
	"./linkedin.svg": 335,
	"./listicle.svg": 336,
	"./live-chat.svg": 337,
	"./liveupdate.svg": 338,
	"./log green.svg": 339,
	"./log grey.svg": 340,
	"./log white.svg": 341,
	"./logic.svg": 342,
	"./login-facebook.svg": 343,
	"./login-google.svg": 344,
	"./login.svg": 345,
	"./logout-mobile.svg": 346,
	"./logout.svg": 347,
	"./longform.svg": 348,
	"./magazines.svg": 349,
	"./mail.svg": 350,
	"./menu-search.svg": 351,
	"./microphone.svg": 352,
	"./minus.svg": 353,
	"./mobile-share.svg": 354,
	"./moderated.svg": 355,
	"./more-outline.svg": 356,
	"./my-vikatan-logo.svg": 357,
	"./mynews.svg": 358,
	"./myvikatanbadge.svg": 359,
	"./narrated.svg": 360,
	"./news.svg": 361,
	"./newsletter.svg": 362,
	"./newslettericon.svg": 363,
	"./olympic.svg": 364,
	"./online-news.svg": 365,
	"./pause.svg": 366,
	"./pdf.svg": 367,
	"./pen.svg": 368,
	"./personalise.svg": 369,
	"./phone.svg": 370,
	"./photo.svg": 371,
	"./photographer.svg": 372,
	"./photostory.svg": 373,
	"./pisces.svg": 374,
	"./play.svg": 375,
	"./plus.svg": 376,
	"./podcast.svg": 377,
	"./podcast_vikatan_menu.svg": 378,
	"./poems.svg": 379,
	"./politics.svg": 380,
	"./premium.svg": 381,
	"./producer.svg": 382,
	"./proofread.svg": 383,
	"./published-by.svg": 384,
	"./published.svg": 385,
	"./rain.svg": 386,
	"./rss.svg": 387,
	"./rupee.svg": 388,
	"./sagitarius.svg": 389,
	"./scorpio.svg": 390,
	"./script-writer.svg": 391,
	"./scripted.svg": 392,
	"./search.svg": 393,
	"./share-alt.svg": 394,
	"./share.svg": 395,
	"./sharechat.svg": 396,
	"./shortform.svg": 397,
	"./shortstories.svg": 398,
	"./shortvideo.svg": 399,
	"./slider-next.svg": 400,
	"./slider-prev.svg": 401,
	"./socialshare.svg": 402,
	"./sort.svg": 403,
	"./sound.svg": 404,
	"./speaker.svg": 405,
	"./speakeraudio.svg": 406,
	"./spiritual.svg": 407,
	"./sponsored.svg": 408,
	"./sports.svg": 409,
	"./star.svg": 410,
	"./stories.svg": 411,
	"./strategy.svg": 412,
	"./stylist.svg": 413,
	"./subscribe-vikatan.svg": 414,
	"./success-icon.svg": 415,
	"./tag.svg": 416,
	"./tamilnadu.svg": 417,
	"./taurus.svg": 418,
	"./technology.svg": 419,
	"./text.svg": 420,
	"./textsms.svg": 421,
	"./thodargal.svg": 422,
	"./thump.svg": 423,
	"./tick.svg": 424,
	"./trending.svg": 425,
	"./twitter-icon.svg": 426,
	"./twitter.svg": 427,
	"./unlike.svg": 428,
	"./uparrow.svg": 429,
	"./update-black.svg": 430,
	"./user-square.svg": 431,
	"./user.svg": 432,
	"./v-plus-logo.svg": 433,
	"./video-editor.svg": 434,
	"./video-icon.svg": 435,
	"./video-play.svg": 436,
	"./video.svg": 437,
	"./videographer.svg": 438,
	"./vikatan-play-logo-red.svg": 439,
	"./vikatan-play.svg": 440,
	"./vikatan-tv.svg": 441,
	"./vikatan.svg": 442,
	"./vikatanconnect.svg": 443,
	"./vikatanplay.svg": 444,
	"./vikatanspl.svg": 445,
	"./vikatantv.svg": 446,
	"./virgo.svg": 447,
	"./whatsapp-icon.svg": 448,
	"./whatsapp-icon1.svg": 449,
	"./whatsapp.svg": 450,
	"./women-home.svg": 451,
	"./writtenarticles.svg": 452,
	"./writtenstory.svg": 453,
	"./youtube.svg": 454
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 206;